import { render, staticRenderFns } from "./GiftInfo.vue?vue&type=template&id=798364fa&scoped=true"
import script from "./GiftInfo.vue?vue&type=script&lang=ts"
export * from "./GiftInfo.vue?vue&type=script&lang=ts"
import style0 from "./GiftInfo.vue?vue&type=style&index=0&id=798364fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798364fa",
  null
  
)

export default component.exports